import { useMutation, UseMutationResult } from '@tanstack/react-query'

import axiosInstance from './axiosInstance'
import { QueryKeys } from './reactQuery'

import {
	ICheckCupomErrorResponse,
	ICheckCupomRequest,
	ICheckCupomSucessResponse,
	IPreRegisterRequest,
	IPreRegisterResponse,
	ISendSubscriptionRequest,
	ISendSubscriptionResponse
} from '../interfaces/form'

import { AxiosError } from 'axios'
import { encrypt } from '../utils/encrypter'

export function useCheckCupom(): UseMutationResult<
	ICheckCupomSucessResponse,
	AxiosError<ICheckCupomErrorResponse>,
	ICheckCupomRequest
> {
	return useMutation([QueryKeys.CHECK_CUPOM], checkCupom)
}

async function checkCupom(payload: ICheckCupomRequest) {

	// const encrypted = encrypt(payload)

	const response = await axiosInstance.post<ICheckCupomSucessResponse>(
		'/app/check-cupom',
		payload
	)

	return response.data
}

export async function preRegister(payload: IPreRegisterRequest) {
	// const encrypted = encrypt(payload)

	const response = await axiosInstance.post<IPreRegisterResponse>(
		'/app/user/pre-register',
		payload
	)

	return response.data
}

export function useSendSubscription(): UseMutationResult<
	ISendSubscriptionResponse,
	AxiosError<ICheckCupomErrorResponse>,
	any
> {
	return useMutation([QueryKeys.SEND_SUBSCRIPTION], sendSubscription)
}

async function sendSubscription(payload: any) {
	// const encrypted = encrypt(payload)

	const response = await axiosInstance.post<ISendSubscriptionResponse>(
		'/app/user/subscription/v3-checkout',
		payload
	)

	return response.data
}
